import React from "react";
import "./forgot.css";
import HeaderLogo from "../components/commons/header";
import { HeaderChange, ContentChange } from "../components/change";

export default function Change() {
  return (
    <div className="container-fluid p-0 overflow-hidden full-page background forgot">
      <div className="h-100 w-100 overflow-auto d-flex flex-column">
        <HeaderLogo/>
        <div className="d-flex offset-sm-5 col-sm-7 align-items-center justify-content-center pb-5 mb-5" style={{flex: "1 1"}}>
          <div className="row flex-column">
            <HeaderChange/>
            <ContentChange/>
          </div>
        </div>
      </div>
    </div>
  );
}